import styled from 'styled-components'

interface FormatProps {
  isText?: boolean
}

export const Modal = styled.div`
  width: 100vw;
  height: 100vh;

  position: fixed;
  top: 0;

  background: rgba(0, 0, 0, 0.75);

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 500;
`

export const Container = styled.div`
  width: 100vw;
  max-width: 778px;

  height: 100vh;

  // overflow: auto;

  background: ${({ theme }) => `rgb(${theme.background.high})`};
  padding: 0.5rem;

  h1 {
    font-size: 1.625rem;
    font-weight: 700;
    line-height: 2.3125rem;
    max-width: 237px;
  }

  p {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.375rem;
    max-width: 289px;
    margin-bottom: 3rem;
  }

  .mobile {
    @media only screen and (min-width: 600px) {
      display: none;
    }
  }

  .desktop {
    @media only screen and (max-width: 600px) {
      display: none;
    }
  }

  @media only screen and (min-width: 600px) {
    border-radius: 16px;
    max-height: 621px;

    height: 95vh;

    > h1,
    > p {
      text-align: center;
      max-width: 90%;
      margin: 1rem auto;
    }
  }
`

export const FormatWrapper = styled.div<FormatProps>`
  cursor: pointer;
  width: 95%;
  max-width: 256px;
  height: 15rem;
  border-radius: 19px;
  background: ${(props) =>
    props.isText
      ? `rgba(${props.theme.background.low}, 0.6)`
      : `rgba(${props.theme.background.low})`};
  margin: 3rem auto 2rem;
  padding: 2rem 1.5rem;

  display: flex;
  flex-direction: column;

  box-shadow: 0px 15px 18px rgba(0, 0, 0, 0.08);

  img {
    width: 95%;
    margin: -4rem auto 0;
  }

  h2 {
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.625rem;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    margin-bottom: 0;
  }

  p {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.375rem;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    margin: 1rem 0;
  }

  span {
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.25rem;
    padding: 0.5rem 1rem;
    color: ${({ theme }) => `rgb(${theme.background.high})`};
    background: ${({ theme }) => `rgb(${theme.primary.base})`};
    border-radius: 46px;
    text-align: center;
    margin: 10px auto -60px;
  }

  &:hover {
    transition: box-shadow 1s;
    box-shadow: 0px 15px 18px rgba(0, 0, 0, 0.25);
  }

  @media only screen and (min-width: 600px) {
    height: auto;
    margin: 1rem auto;
    padding: 1.5rem;

    img {
      margin: 0 -2.5rem 0;
      width: 300px;
    }
  }
`

export const Wrapper = styled.div`
  @media only screen and (max-width: 600px) {
    .video {
      margin-top: 6rem;
    }
  }
  @media only screen and (min-width: 600px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 1rem;
  }
`
